import React from "react";
import styles from "./PoweredBy.module.scss";
import { default as AppIcon } from "../../assets/images/applogo.png";
import { ReactComponent as LockIon } from "../../assets/images/lock.svg";

type PoweredByProps = {
  device?: string;
};
const PoweredBy = ({ device = "laptop" }: PoweredByProps) => {
  return (
    <div key={Math.random() * 1000} className={styles["poweredByContainer" + device]}>
      <div className={styles.poweredByLogo}>
        <LockIon /> Secured by
        <img src={AppIcon} className={styles.appLogo} />
        {/* <AppIcon key={Math.random() * 1000} className={styles.appLogo} /> */}
      </div>
    </div>
  );
};

export default PoweredBy;
